// extracted by mini-css-extract-plugin
module.exports = {"message":"_8fc4a5f"};